jQuery(document).foundation();


jQuery(document).ready(function($) {
	


/* ANIMATIONS
------------------------------------*/
	function animations() {
		var controller = new ScrollMagic.Controller();
		
		$(window).load(function() { 
		/* blocks */
		var blocks = new ScrollMagic.Scene({
	        triggerElement: '#blocks', 
	        triggerHook: 1,
	        offset: 100
	    })
	    .setTween(TweenMax.staggerFrom('#blocks .blocks', 1, {y: '90%', autoAlpha:0, ease: Power3.easeOut}, 0.1))
	    .addTo(controller);
	    });
		
		/* icons */
		var icons = new ScrollMagic.Scene({
	        triggerElement: '#icons', 
	        triggerHook: 1,
	        offset:200
	    })
	    .setTween(TweenMax.staggerFrom('#icons article', 0.5, {y: '50px', autoAlpha:0, ease: Power3.easeOut}, 0.3))
	    .addTo(controller);
	    
	    /* call */
		var call = new ScrollMagic.Scene({
	        triggerElement: '#call', 
	        triggerHook: 1,
	        offset:200
	    })
	    .setTween(TweenMax.staggerFrom('#call .row', 0.5, {x: '50px', autoAlpha:0, ease: Power3.easeOut}, 0.3))
	    .addTo(controller);

		/* Parallax */
		var parallax = new ScrollMagic.Scene({
	        triggerElement: '#parallax', 
	        triggerHook: 1,
	        duration: "200%"
	    })
	    .setTween(TweenMax.from('#bcg', 1, {y: '-50%', ease: Power0.easeNone}))
	    .addTo(controller);
	    
	    /* title */
	    var title = new ScrollMagic.Scene({
	        triggerElement: '#parallax', 
	        triggerHook: 1,
	        duration: "150%"
	    })
	    .setTween(TweenMax.from('#parallax h2', 1, {y: '-80px', autoAlpha:0, ease: Power3.easeOut}))
	    .addTo(controller);
	    
	    /* red circles */
	    var circles = new ScrollMagic.Scene({
	        triggerElement: '#parallax', 
	    })
	    .setTween(TweenMax.staggerFrom('.box-icon figure', 0.5, {y: '80px', autoAlpha:0, scale:0.6, ease: Power3.easeOut}, 0.3))
	    .addTo(controller);
	    
	    /* red circles titles */
	    var circles = new ScrollMagic.Scene({
	        triggerElement: '#parallax', 
	    })
	    .setTween(TweenMax.staggerFrom('.box-icon h5', 0.5, {y: '-10px', autoAlpha:0, ease: Power3.easeOut}, 0.3))
	    .addTo(controller);
	    
	    /* Hand */
		var hand = new ScrollMagic.Scene({
	        triggerElement: '#app', 
	        triggerHook: 1,
	        duration: "200%"
	    })
	    .setTween(TweenMax.from('#hand', 1, {y: '100%', autoAlpha:0, ease: Power3.easeOut}))
	    .addTo(controller);
	    
	    /* app buttons */
		var app = new ScrollMagic.Scene({
	        triggerElement: '#app', 
	        triggerHook: 1,
	        offset:400
	    })
	    .setTween(
		TweenMax.staggerFrom('.anim', 0.4, {y:'20px', autoAlpha:0, ease: Power3.easeOut}, 0.3) 
	    ).addTo(controller);
	    
	    /* Woman */
		var woman = new ScrollMagic.Scene({
	        triggerElement: '#call-02', 
	        triggerHook: 1,
	        duration: "100%"
	    })
	    .setTween(TweenMax.from('#woman', 1, {y: '30%', autoAlpha:0, ease: Power3.easeOut}))
	    .addTo(controller);
	    
	    /* Pay */
		var pay = new ScrollMagic.Scene({
	        triggerElement: '#call-02', 
	        triggerHook: 1,
	        offset:400
	    })
	    .setTween(TweenMax.staggerFrom(['.anim-left img', '.anim-left h3', '.anim-left a'], 0.7, {x: '-20%', autoAlpha:0, ease: Power3.easeOut}, 0.4))
	    .addTo(controller);

	}
	
	if($('body').hasClass('home')) {
		animations();
	}

	
/* LABELS
------------------------------------*/
	$('#blocks input').on('mousedown', function(){
		$(this).parent('label').css('color', '#c32c09');
	}); 

	
/* PREVENT EMPTY SEARCH
------------------------------------*/
	$('#search-form').bind('submit', function(){
		if( $(this).find('input[type="text"]').val() === '' )
		return false; 
	}); 


/* ORBIT BIND
------------------------------------*/
/*
	$('#orbit-previous').on('click', function(){
		$('.orbit-previous').trigger('click');
	});
	$('#orbit-next').on('click', function(){
		$('.orbit-next').trigger('click');
	});
*/
 
/* REMOVE USELESS EMPTY P IN ACCORDION
------------------------------------*/
    $('.accordion p:empty, .orbit p:empty').remove();
	
	
	
/* STICKY MAIN
------------------------------------*/
	function stickymain() {
		var limit = $(window).innerHeight() - $('header#header').innerHeight() - $('footer#footer').innerHeight();
		if( !$('body').hasClass('mobile') &&  limit > $('#main').innerHeight() ) {			
			$('#main').css('height', limit );
		}
	}
	
	$(window).load(function() { 
		stickymain();	
	});
	$(window).resize(function() { 
		stickymain();
	});
	
	
/* LOADER + SLIDER
------------------------------------*/
	//TweenMax.to('#loader', 0.5, {opacity:0, delay:1, ease:Power2.easeOut});
	//TweenMax.to('#loader', 0.5, {visibility:'hidden', opacity:0, delay:1.5});
	
	function slider() {
		$("ul#slider, ul#slider article, ul#slider div.row")
		.css('height' , $(window).height() );
	}
	//setTimeout(slider, 1000);
		
	$(window).resize(function() { 
		slider();
	}); 
	$(window).load(function() { 
		slider();
		TweenMax.to('body', 0.5, {autoAlpha:1});
	}); 
	    
	$("div.orbit").on("slidechange.zf.orbit", function() {
		TweenMax.to(['ul#slider h1', 'ul#slider h2'], 1.3, {opacity:0, x:150});
		TweenMax.to(['ul#slider h1', 'ul#slider h2'], 0.3, {delay:0.5, opacity:1, x:0, ease: Back.easeOut.config(1.9)});
	});

   
    
    
/* GO TOP
------------------------------------*/
	$('#go-top').on('click', function() {
        $('html,body').animate({ scrollTop: 0 }, 700);
        return false;
    });
    
    
    
/* FANCYBOX GALLERY
------------------------------------*/
    $(".fancybox-thumb").fancybox({
		helpers	: {
			title	: {
				type: 'outside'
			},
			thumbs	: {
				width	: 100,
				height	: 100
			},
			overlay: {
		      locked: false
		    }
		}
	});
	$('#the-content img').parent('a').fancybox({
		helpers	: {
			title	: {
				type: 'outside'
			},
			overlay: {
		      locked: false
		    }
		}
	});





	
/* CLOSING DOCUMENT.READY
------------------------------------*/
}); 
 
 
 
/* AJAX HELPERS
------------------------------------*/
/*
jQuery(document).ready(function($) {
			
	var num = 8;
	$('.load-more').each(function(){
		$(this).on('click', function(){
			
			$(this)
			.html('<img src="'+url+'/img/oval.svg" class="loading" />')
			.delay(2000)
			.fadeOut();
			
			$('<div/>', {
			    class: 'more-content',
			}).insertAfter(this);
			
			$('<a/>', {
			    class: 'button load-more expand margin-30-0',
			    style:'display:none;',
			    href: '#',
			    text: 'Carica più articoli',
			}).insertAfter('div#wrapper div.more-content:last-child')
			.delay(2000)
			.fadeIn();
			
			$('html, body').delay(2000).animate({scrollTop:$('div#wrapper div.more-content').last().offset().top - 120}, 1000);
			
			$('#offset').attr('value', num);
			$('#load-more-form').trigger('submit');
			num= num + 8;
			
			return false;
		});	
	});

	$('#load-more-form').bind('submit', function ( event ) {	
		var datamore = $(this).serialize ();	
		setTimeout("load_more('"+datamore+"','"+$(this).attr('action')+"')",1000);
		return false;
	});



});//document

var xhr; // inizializzo oggetto globale

function load_more(datamore,dest_url){

	// quando ci sono chiamate uguali e precedenti, elimino la chiamata
    if(xhr && xhr.readystate != 4){ 
        xhr.abort();
    }
    xhr = jQuery.ajax({
        type: "POST",
		url:dest_url,
		data: datamore,
		dataType: "json",
		cache: false,
		success: function(html){	
			jQuery('div#wrapper div.more-content').last().html(html.status);	
			
			var num = parseInt(jQuery('#offset').attr('value'));
			jQuery('.load-more').each(function(){
				jQuery(this).on('click', function(e){
					
					$(this)
					.html('<img src="'+url+'/img/oval.svg" class="loading" />')
					.delay(2000)
					.fadeOut();
					
					$('<div/>', {
					    class: 'more-content',
					}).insertAfter(this);
					
					$('<a/>', {
					    class: 'button load-more expand margin-30-0',
					    style:'display:none;',
					    href: '#',
					    text: 'Carica più articoli',
					}).insertAfter('div#wrapper div.more-content:last-child')
					.delay(2000)
					.fadeIn();
					
					$('html, body').delay(2000).animate({scrollTop:$('div#wrapper div.more-content').last().offset().top - 120}, 1000);

					jQuery('#offset').attr('value', num + 8);
					jQuery('#load-more-form').trigger('submit');
					return false;
				});	
			});
			
		}
    });
}
*/